/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateOrganisationAccessModeDataAccessModeSchema } from './UpdateOrganisationAccessModeDataAccessModeSchema'

export const updateOrganisationAccessModeDataSchema = z.object({
	accessMode: updateOrganisationAccessModeDataAccessModeSchema.nullable().optional(),
})

export type UpdateOrganisationAccessModeDataSchema = z.infer<typeof updateOrganisationAccessModeDataSchema>
